import { render, staticRenderFns } from "./BatteryAndInverter.vue?vue&type=template&id=bc8076bc&scoped=true"
import script from "./BatteryAndInverter.vue?vue&type=script&lang=js"
export * from "./BatteryAndInverter.vue?vue&type=script&lang=js"
import style0 from "./BatteryAndInverter.vue?vue&type=style&index=0&id=bc8076bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8076bc",
  null
  
)

export default component.exports